import { apiClient } from '@api/client';
import type { StripeConnection } from '@/types/payments';

export async function fetchStripeConnection() {
  const { data } = await apiClient.get<StripeConnection>('/payments/providers/stripe/connection');
  return data;
}

export async function startStripeConnection(payload: { return_path?: string; force_reconnect?: boolean; country?: string }) {
  const { data } = await apiClient.post<StripeConnection>('/payments/providers/stripe/connection/start', payload);
  return data;
}

export async function refreshStripeConnection() {
  const { data } = await apiClient.get<StripeConnection>('/payments/providers/stripe/connection/refresh');
  return data;
}
